import { Component, inject } from '@angular/core';
import { AppConfigService } from '@app/core/services/config.service';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { LanguagePickerModalComponent } from '../language-picker-modal/language-picker-modal.component';
import { CultureInfo } from '@app/core/types/config/config.types';
import { TranslationSandbox } from '@app/core/sandboxes/translation.sandbox';

@Component({
    selector: 'c-language',
    templateUrl: './language.component.html',
    standalone: false
})
export class LanguageComponent {
  private readonly appConfigService = inject(AppConfigService);
  private readonly translationSandbox = inject(TranslationSandbox);
  private readonly modalController = inject(ModalController);

  cultureInfos: CultureInfo[] = this.appConfigService.cultureInfos;
  selectedLanguage$: Observable<CultureInfo> = this.translationSandbox.selectedCulture$;
  loading$ = this.translationSandbox.languageLoading$;

  async initLanguagePicker(): Promise<void> {
    const modal = await this.modalController.create({
      component: LanguagePickerModalComponent,
      componentProps: {
        languages: this.cultureInfos,
        close: (language: CultureInfo) => modal.dismiss(language),
      },
      cssClass: ['auto-height-modal'],
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      handle: false
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.translationSandbox.changeLanguage(data.data.cultureCode);
      }
    });
  }
}
